			document.addEventListener("DOMContentLoaded", function () {
				// window.onload = function () {
				const swiper01 = new Swiper(".imgTxtBox01  .swiper", {
					loop: true,
					speed: 1000,
					slidesPerView: 1,
					centeredSlides: false,
					// navigation: {
					//   nextEl: ".swiper-button-next",
					//   prevEl: ".swiper-button-prev",
					// },
					autoplay: {
						delay: 2500,
						pauseOnMouseEnter: true,
						disableOnInteraction: false,
					},

					pagination: {
						el: ".swiper-pagination",
						clickable: true,
						dynamicBullets: false,
					},
				});
			});
